/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc).attr('srcset', '').attr('sizes', '');
};

function doRepeat(time1, time2, callback) {
    var timerId = setInterval(function() {
        callback();
    }, time1);

    setTimeout(function() {
        clearInterval(timerId);
    }, time2);
}

jQuery(function($) {
  var window_change_width = 730;

  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
  /*==========================*/
  
  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }  
  if (!supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }
  
  /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
  /*==========================*/ 
  var images = $('.article img').on('load', function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumbs a').on('click', function(e) { 
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );

  // On click of a shipping option set the currency correctly
  $('.shipping-location>a').text($('.shipping-options a.selected-currency').data('country-name'));
  function updateCountryNames() {
    $(".shipping-options a").each(function() {
      $(this).text($(this).data('country-name'));
    });
  }
  updateCountryNames();
  $('.shipping-location>a').on('click', function(e){
    var shippingSelect = $('.shipping-options');
    if(shippingSelect.hasClass('animate')) {
      shippingSelect.removeClass('animate');
    } else {
      shippingSelect.addClass('animate');
    }
    e.preventDefault();
  });
  $('.shipping-options a').click(function(e){
    var country = $(this).data('currency'),
        selected = $(this).text();
    $('[name=currencies]').val(country).change();
    $('.shipping-location>a').text(selected);
    $('.shipping-options').removeClass('animate');
    updateCountryNames();
    e.preventDefault();
  });
  $('.shipping-location a').blur(function(){
    $('.shipping-options').removeClass('animate');
  });
  
  var alignContents = function()  {
    setTimeout(function(){
      var articleHeight = $('.article .image-container').height();
      $('.body.excerpt').height(articleHeight);
    }, 500);
  }

  alignContents();
  $(window).resize(function() {
    alignContents();
  });

  $('.resp-nav').on('click', function(e){
    e.preventDefault();
    var html = $('html');
    if(html.hasClass('resp')) {
      html.removeClass('resp');
    } else {
      html.addClass('resp');
    }
  })

  $('.close-nav').on('click', function(e){
    var html = $('html');
    html.removeClass('resp');
    e.preventDefault();
  })

  $(window).resize(function() {
      if (window.innerWidth >= window_change_width) {
          var html = $('html');
          html.removeClass('resp');
      }
  });

  /* Search form in navigation */

  var searchFormTimer = null;

  var searchFormTimerStart = function (timer) {
      timer = setTimeout(function(){$('.nav .search-form').addClass('hidden');}, 4000);
      return timer;
  }
  var searchFormTimerStop = function (timer) {
      clearTimeout(timer);
      timer = null;
      return timer;
  }

  $(".search-input-nav")
      .focusout(function(){
          searchFormTimer = searchFormTimerStart(searchFormTimer);
      })
      .focus(function(){
          searchFormTimer = searchFormTimerStop(searchFormTimer);
      });

  $('.nav-search-open').click(function(){
      var form = $('.nav .search-form');

      form.each(function (e) {
          var input = $(this).find(".search-input-nav");
          if ($(this).hasClass('hidden') || !input.val()) {
              $(this).toggleClass('hidden');
              setTimeout(function () {
                  input.focus();
              }, 300);
          } else {
              $(this).submit();
          }
      });
  });

  /* Placeholder for eu-cookie-banner */
  function setCookiesBannerPlaceholder(hide) {
      var cc_banner = $('.cc_container.cc_banner'),
          cc_banner_placeholder = $('.cc_banner_placeholder');

      if (cc_banner_placeholder.length == 0){
          $('.site-footer, nav.nav').append('<div class="cc_banner_placeholder"></div>');
          cc_banner_placeholder = $('.cc_banner_placeholder');
      }

      if (window.innerWidth < window_change_width || cc_banner.length == 0){
          cc_banner_placeholder.css({
              width: '100%',
              height: cc_banner.outerHeight(),
              display: (cc_banner.css('display') == 'none') || (hide == true) ? 'none' : 'block'
          })
      } else {
          cc_banner_placeholder.css({
              display: 'none'
          })
      }
  }

  $(document).on('click', '.cc_btn_accept_all', function(){
      setCookiesBannerPlaceholder(true);
  });

  doRepeat(200, 10000, function() {
      setCookiesBannerPlaceholder();
  });

  $(window).resize(function() {
      setCookiesBannerPlaceholder();
  });

});

/* Google Analtyics - For EU/Worldpay only */
/*==========================*/ 

  $(document).ready(function() {
  if (isEur === true) { 
    if(window.location.pathname === '/pages/thank-you') {

      window['ga'] = window['ga'] || function() { 
        (window['ga'].q=window['ga'].q||[]).push(arguments);
      }

      jQuery.extend({
        getQueryParameters : function(str) {
            return (str || document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = n[1],this}.bind({}))[0];
        }
      });

      var queryParams = $.getQueryParameters();
      var gbp = /^%C2%A3/;
      var eur = /^EUR/;
      var curr;
      var payment;

      var currTest = gbp.test(queryParams.amt);
      if(currTest === true) {
        curr = 'GBP';
        payment = queryParams.amt.slice(6);
      } else {
        currTest = eur.test(queryParams.amt);
        if (currTest === true) {
          curr = 'EUR';
          payment = queryParams.amt.slice(3);
        } else {
          curr = '';
          payment = queryParams.amt;
        }
      }

      ga('require', 'ecommerce');
      ga('ecommerce:addTransaction', {
        'id': queryParams.id,
        'revenue': payment,
        'currency': curr
      });
      ga('ecommerce:addItem', {
        'id': queryParams.id,
        'price': payment, 
        'currency': curr
      });
      ga('ecommerce:send');
    }
  }
  
  /* Facebook Share */
  /*==========================*/ 
  $('.facebook-share').on('click', function(evt) {
    evt.preventDefault();
    FB.ui({
      method: 'share',
      mobile_iframe: true,
      href: window.location.href,
    }, function(response){});
  });

  /* Testimonial Slider */
  /*==========================*/
  var testimonials = $('.testimonials');
  if (testimonials.length) {
    testimonials.slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
      arrows: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }

});